export const CouldNotInsertHyperLinkTitle = "JOb";
export const BrowseCloudLocationsHyperLink = "KOb";
export const BrowseCloudLocationsOnlyAllowOneFile = "LOb";
export default {CouldNotInsertHyperLinkTitle,BrowseCloudLocationsHyperLink,BrowseCloudLocationsOnlyAllowOneFile};